module.exports = __webpack_public_path__ + "img/Forsmax_Gray_1280x1010.4e37c553.jpg";